import React from "react";
import NoData from "../../NoData";
import DrugItem from "./DrugItem";

const OutOfStockDrugs = ({ drugs }) => {
  return (
    <div className="card h-100">
      <div className="card-header border-0 order-header-shadow">
        <h5 className="card-title d-flex justify-content-between flex-grow-1">
          <span>Out Of Stock Drugs</span>
        </h5>
      </div>
      <div className="card-body" style={{ maxHeight: "500px", overflow: "auto" }}>
        {drugs?.map((drug, index) => (
          <DrugItem
            key={index}
            drug={drug}
            badgeLabel="Left"
            badgeValue={drug?.quantity}
          />
        ))}
        {drugs?.length <= 0 && <NoData />}
      </div>
    </div>
  );
};

export default OutOfStockDrugs;